import { IAssigneesStoreState, IAssignee, AssigneeActions } from "@gtmhub/assignees";
import { GtmhubController } from "@gtmhub/core";
import { INgRedux } from "@gtmhub/state-management";
import { IdMap } from "@gtmhub/util";
import { IComponentOptions, IOnChangesObjectOf } from "angular";
import { AvatarSize } from "../..";

interface IUsersListTooltipBindings {
  ids: string[];
  size: AvatarSize;
}

interface IUsersListTooltipComponentRedux {
  assignees: IdMap<IAssignee>;
}

const bindStateToCtrl = (state: IAssigneesStoreState) => {
  return {
    assignees: state.assignees.map,
  };
};

/**
 * @example <users-list-tooltip ids="goal.ownerIds" size="small"></users-list-tooltip>
 * @param ids string[]
 * @param size "s-17" | "s-20" | "s-24" | "s-26"
 * @param class string : "dropdown-menu list"
 */
export interface UsersListTooltipCtrl extends IUsersListTooltipBindings, IUsersListTooltipComponentRedux {}
export class UsersListTooltipCtrl extends GtmhubController {
  static $inject = ["$ngRedux", "AssigneeActions"];

  constructor($ngRedux: INgRedux, assigneeActions: AssigneeActions) {
    super();

    this.onDestroy($ngRedux.connect(bindStateToCtrl)(this));
    $ngRedux.dispatch(assigneeActions.getAssignees());
  }

  $onChanges(changesObj: IOnChangesObjectOf<IUsersListTooltipBindings>): void {
    const ids = changesObj.ids;
    const idsValue = (ids && ids.currentValue) || [];
    this.ids = idsValue;
  }
}

export const UsersListTooltipComponent: IComponentOptions = {
  controller: UsersListTooltipCtrl,
  templateUrl: require("./users-list-tooltip.jade"),
  transclude: true,
  bindings: {
    ids: "<",
    size: "@",
    class: "@",
  },
};
